module.exports = __webpack_public_path__ + "static/media/arrow-alt-left.d055027c.svg";